import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { editKpiAlert, editKpiAlertForRan } from '@api/kpiAlerts';

import { TOnSuccessOnError } from '@interfaces/common/handlers';
import { IEditAlertDTO } from '@interfaces/kpi/dto/kpiAlertsDTO';

import { EVendorsValues, TVendorsValues } from '@enums/common';

import { EDIT_KPI_ALERT, KPI_ALERTS, KPI_ALERTS_BY_ID, KPI_ALERTS_ORAN } from '@constants/queryKeys';

export interface IUseEditKpiAlertReturnedValues {
	editKpiAlert: (data: IEditAlertDTO) => void;
	isLoadingEditKpiAlert: boolean;
}

export interface IUseEditKpiAlertParams extends Partial<TOnSuccessOnError> {
	vendor?: TVendorsValues | null;
}

export function useEditKpiAlert({
	onSuccess,
	onError,
	vendor,
}: IUseEditKpiAlertParams): IUseEditKpiAlertReturnedValues {
	const queryClient = useQueryClient();

	const editFn = vendor === EVendorsValues.oran
		? editKpiAlertForRan
		: editKpiAlert;

	const {
		mutate,
		isLoading: isLoadingEditKpiAlert,
	} = useMutation<IEditAlertDTO>({
		mutationKey: [EDIT_KPI_ALERT],
		mutationFn: editFn,
		onSuccess: (data) => {
			if (onSuccess) onSuccess();

			return [
				queryClient.invalidateQueries([KPI_ALERTS]),
				queryClient.invalidateQueries([KPI_ALERTS_BY_ID, data.id]),
				queryClient.invalidateQueries([KPI_ALERTS_ORAN]),
			];
		},
		onError: () => {
			if (onError) onError();
		},
	});

	return { editKpiAlert: mutate, isLoadingEditKpiAlert };
}
